import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Apply from './pages/Apply';
import Schedule from './pages/Schedule';
import TopPage from './pages/Top_Page';
import Member from './pages/Member';
import Team from './pages/Team';
import Detail from './pages/Detail';
import largeImage_mobile from './images/loading_animation.jpg';


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // ローディングを3秒後に解除（ここではサンプルとして3秒）
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3秒後にローディングを解除

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <ScrollToTop />
      {isLoading ? (
        <div className="loading">
          <img src={largeImage_mobile} alt="Loading" className="loading-image" />
        </div>
      ) : (
        <div>
          <Routes>
            <Route path="/" element={<TopPage />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/member" element={<Member />} />
            <Route path="/team" element={<Team />} />
            <Route path="/detail" element={<Detail />} />
          </Routes>
        </div>
      )}
    </>
  );
}

export default App;
